var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',[_vm._v("服饰名称")])]),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"lease_check_order_detail_rt"},[_vm._v(_vm._s(_vm.order_detail.goods_name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }